import React, { FC } from 'react';
import cn from 'classnames';

import {
  CarsItem as CarsItemWrap,
  CarsItemImg,
  CarsItemImgsPreview,
  CarsItemInfo,
  CarsItemOptions,
  CarsItemFinance,
  getSpecification,
} from '@azgaz/azgaz-ui';

import { config } from '@/utils';
import { TBrandCar } from '@/selectors/getBrandCar';
import { getImages, getCarFirstThumb } from '@/selectors';

import outsideComponents from '../../outsideComponents';
import CarStatus from '../CarStatus';

import style from './style.module.scss';
import CarGroup from '../CarGroup';

type CarsItemProps = {
  car: NonNullable<TBrandCar>;
};

const fields = [
  {
    source: 'root',
    id: 'color.name',
    title: 'Цвет',
  },
  {
    source: 'root',
    id: 'year',
    title: 'Год выпуска',
  },
  {
    source: 'root',
    id: 'mileage',
    title: 'Пробег',
  },
];

const featureFlagFilteringByStatus = config.get('featureFlagFilteringByStatus');
const groupFilterEnable = config.get('groupFilterEnable');

const CarsItem: FC<CarsItemProps> = ({ car }) => {
  const { id, model, specification, grade } = car;

  const imgAttrs = getCarFirstThumb(car);
  const carImgs = getImages(car);
  const { DealerInfo, CarsItemPrice } = outsideComponents;

  const [drive, transmission, engine] = ['drive', 'transmission', 'engine'].map(
    i => getSpecification(specification, 'main', i) || ''
  );

  const carInfo = `${engine} ${drive} ${transmission} ${grade}`;
  const isGroupVisible = groupFilterEnable || featureFlagFilteringByStatus;

  return (
    <CarsItemWrap id={id}>
      {carImgs.length > 1 ? (
        <CarsItemImgsPreview imgs={carImgs} />
      ) : (
        <CarsItemImg src={imgAttrs.url} alt={imgAttrs.alt} />
      )}
      <div className={style.labels}>
        {!!isGroupVisible && !!car.group && (
          <CarGroup status={car.group} className={style.label} />
        )}
      </div>
      <CarsItemInfo title={model}>
        <div className={cn(style['car-info'], 'mb-2')}>{carInfo}</div>
        <CarsItemOptions car={car} fields={fields} />
        {/* <ColorOption color={car.color} /> */}
        {CarsItemPrice && (
          <CarsItemFinance>
            <CarsItemPrice car={car} />
          </CarsItemFinance>
        )}
        {DealerInfo && (
          <DealerInfo car={car} className={style['dealer-info']} />
        )}
      </CarsItemInfo>
    </CarsItemWrap>
  );
};

export default CarsItem;
